module.exports = __webpack_public_path__ + "images/51b0dba7ff2ec4838850ed10b168c245.png";